import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import ScrollablePageTab from "../../dynamicForm/components/ScrollablePageTab";
import EvidenceImageViewer from "../EvidenceImageViewer";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

export default function EvidenceViewer({
  evidences,
  eventId,
  setSelectedEvidence,
  notes,
  selectedEvidenceId,
}) {
  const [selectedPageIndex, setSelectedPageIndex] = useState(
    selectedEvidenceId &&
      selectedEvidenceId > 0 &&
      evidences &&
      evidences.length > 0
      ? Math.max(
          evidences.findIndex((x) => x.Id === selectedEvidenceId),
          0,
        )
      : 0,
  );
  const [viewer, setViewer] = useState();

  useEffect(() => {
    if (selectedPageIndex >= 0) {
      setSelectedEvidence(evidences[selectedPageIndex]);
      setViewer(
        <Box className="flex gap-2 w-full">
          <Button
            disabled={selectedPageIndex === 0}
            onClick={() => {
              setSelectedPageIndex((x) => x - 1);
            }}
          >
            <ArrowLeft />
          </Button>
          <EvidenceImageViewer
            paramId={eventId}
            paramType={evidences[selectedPageIndex].EvidenceType}
            paramEvidenceId={evidences[selectedPageIndex].Id}
            evidencesData={{ Data: evidences }}
            dontUseLoadingFullScreen
            galleryMode
            evidenceNotes={notes}
          />
          <Button
            disabled={selectedPageIndex >= evidences?.length - 1}
            onClick={() => {
              const newPageIndex = Math.min(
                selectedPageIndex + 1,
                evidences?.length - 1,
              );
              setSelectedPageIndex(newPageIndex);
            }}
          >
            <ArrowRight />
          </Button>
        </Box>,
      );
    }
  }, [selectedPageIndex]);

  return (
    <Box sx={{ width: "850px", maxHeight: "500px" }}>
      {evidences && (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <ScrollablePageTab
            selectedPage={selectedPageIndex}
            setSelectedPage={setSelectedPageIndex}
            dynamicFormPages={evidences}
            maxWidthValue={"830px"}
          />

          {viewer}
        </Box>
      )}
    </Box>
  );
}
